import { atom } from "recoil";
import { IDataCon } from "../types";

export const addStateDataConnection = atom({
  key: "addStateDataConnection",
  default: false,
});
export const editStateDataConnection = atom({
  key: "editStateDataConnection",
  default: false,
});
export const rowEditDataConnection = atom<IDataCon | undefined>({
  key: "rowEditDataConnection",
  default: undefined,
});

export const selectedRowsStateDataConnection = atom<IDataCon[]>({
  key: "selectedRowsStateDataConnection",
  default: [],
});

export const dataConnectionFilterText = atom({
  key: "dataConnectionFilterText",
  default: "",
});

export const dataConnectionFetching = atom({
  key: "dataConnectionFetching",
  default: true,
});
export const dataConnectionReFetching = atom({
  key: "dataConnectionReFetching",
  default: false,
});
